import React from "react";
import SwipeableViews from "react-swipeable-views";
import { activityPageStyles } from "./activities.styles";
import {
  AppBar,
  Box,
  Tab,
  Tabs,
  Typography,
  useTheme,
} from "@material-ui/core";
import PageHeader from "app/main/shared-components/page-header/PageHeader";
import history from "@history";
import ReservationActivityTab from "./ReservationActivityTab";
import TravelerActivityTab from "./TravelerActivityTab";
import { useTranslation } from "react-i18next";
import FlightHistoryTab from "./FlightHistoryTab";
import ReservationHistoryPage from "../reservation-history/ReservationHistoryPage";
import { useLocation } from "react-router-dom";

function TabPanel(props: any) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const ActivitiesPage = () => {
  const classes = activityPageStyles();
  const theme = useTheme();
  const { t } = useTranslation();
  const location = useLocation();

  const isSchedule = location.pathname.includes("/schedules/");

  // Tabs definition
  const tabs = isSchedule
    ? [
        {
          label: t("app.main.schedules.activities.tab1", "Reservation"),
          content: <ReservationActivityTab />,
        },
        {
          label: t("app.main.schedules.activities.tab2", "Passengers"),
          content: <TravelerActivityTab />,
        },
        {
          label: t("app.main.schedules.activities.tab3", "History"),
          content: <ReservationHistoryPage />,
        },
      ]
    : [
        {
          label: t("app.main.schedules.activities.tab4", "Flight History"),
          content: <FlightHistoryTab />,
        },
      ];

  const [value, setValue] = React.useState(0);

  const handleChange = (_event: any, newValue: number) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index: number) => {
    setValue(index);
  };

  return (
    <div className={classes.root}>
      <PageHeader
        backButton={() => history.goBack()}
        title={t("app.main.schedules.activities.title", "Activities")}
        desc={t(
          "app.main.schedules.activities.desc",
          "History of activities related to reservations and passengers."
        )}
      />
      <AppBar position="static" color="default" elevation={0}>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="standard"
        >
          {tabs.map((tab, idx) => (
            <Tab key={idx} label={tab.label} {...a11yProps(idx)} />
          ))}
        </Tabs>
      </AppBar>
      <SwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        {tabs.map((tab, idx) => (
          <TabPanel key={idx} value={value} index={idx} dir={theme.direction}>
            {tab.content}
          </TabPanel>
        ))}
      </SwipeableViews>
    </div>
  );
};

export default ActivitiesPage;
